import type { MailboxInfo, AccountKey } from 'owa-client-types';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';
import { logCoreUsage } from 'owa-analytics';
import type { CopilotEnablementDiagnostics } from 'owa-copilot-settings-store/lib/utils/enablementCodes/CopilotEnablementTypes';

// Set to track which mailboxes have already logged telemetry
const loggedMailboxes = new Set<AccountKey>();

/**
 * Logs BizchatSidepaneEnablementDiagnostics telemetry once per mailbox
 * @param mailboxInfo The mailbox to log for
 * @param diagnostics The diagnostics to log
 */
export function logBizchatSidepaneEnablementDiagnostics(
    mailboxInfo: MailboxInfo,
    diagnostics: CopilotEnablementDiagnostics,
    cohort?: string
): void {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);

    // Only log if we haven't logged for this mailbox yet
    if (!loggedMailboxes.has(accountKey)) {
        loggedMailboxes.add(accountKey);

        logCoreUsage('BizchatSidepaneEnablementDiagnostics', mailboxInfo, {
            enablementDiagnostics: diagnostics.code,
            userCohort: cohort,
        });
    }
}
